import * as tslib_1 from "tslib";
import { CanActivate, Router } from '@angular/router';
import { ConfigService } from '../services/config.service';
import * as i0 from "@angular/core";
import * as i1 from "../services/config.service";
import * as i2 from "@angular/router";
export class VariantSelectorGuard {
    constructor(configService, router) {
        this.configService = configService;
        this.router = router;
    }
    canActivate() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //Wait for the company info to be loaded
            yield this.configService.getInitialInfo();
            // Now validate if the company has multiple variants
            let variants = this.configService.company_info.variants;
            if (variants.length > 1) {
                return true;
            }
            this.router.navigateByUrl('/inicio');
            return false;
        });
    }
}
VariantSelectorGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VariantSelectorGuard_Factory() { return new VariantSelectorGuard(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i2.Router)); }, token: VariantSelectorGuard, providedIn: "root" });
